import Dexie from 'dexie'

const db = new Dexie('firstnames' );

async function insertNames(t) {
  // load replacement list (lazy-import keeps v1 bundles small)
	const { default: rows } = await import(/* webpackChunkName:"firstnames2" */ '@/lib/firstnames.array.2.json');

  // replace the contents
  // await t.names.clear();
  // await t.names.bulkAdd(rows.map(({ n, g }) => ({ name: n, gender: g })));
	db.names.bulkPut(rows.map(name => ({ name: name.n, gender: name.g })));
}

function init() {
  if (db.isOpen())
    return;

  console.debug("name/gender db init");
   
  db.version(1).stores({
    names: 'name,gender'
  });
	
	db.version(2).stores({
	  // schema unchanged
	  names: 'name,gender'
	})
	.upgrade(async t => {
	  // t is the open RW transaction for all tables declared above
	  console.debug('firstnames → v2 data refresh');
		insertNames(t);
	});
	
	
  // Don't call on(populate) because network requests are async
  // and the db transaction will close before our request comes
  // back. See https://dexie.org/docs/Dexie/Dexie.on.populate
  //
	db.on('ready', async () => {
	  const count = await db.names.count();
	  console.debug("NameChecker got count:", count);

	  if (count < 1) {
			insertNames(db);
	  }
	});
  
  db.open()
}

async function checkName(name) {
  const entry = await db.names.get(name);
  return entry && entry.gender;
}

export default { init, checkName };